var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.add")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click() {
        return _vm.close();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-window', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.Steps.FORM
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('rental-form', {
    attrs: {
      "showCompany": false,
      "report": _vm.report
    },
    scopedSlots: _vm._u([{
      key: "fileUpload",
      fn: function fn() {
        return [_c('drop-area-multi', {
          staticClass: "mb-4",
          attrs: {
            "files": _vm.files,
            "loading": _vm.requestsLoading,
            "accept": ".pdf",
            "maxFiles": 1
          },
          on: {
            "update:files": function updateFiles($event) {
              _vm.files = $event;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.rental,
      callback: function callback($$v) {
        _vm.rental = $$v;
      },
      expression: "rental"
    }
  })], 1)], 1), _c('v-divider', {
    staticClass: "d-none d-md-block",
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.PartnerReportSelectRentalCompanyCard.title")) + " ")]), _vm.report.rentalCompanyId ? _c('company-sheet', {
    attrs: {
      "company": _vm.report.rentalCompany
    }
  }) : _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.rental.PartnerReportSelectRentalCompanyCard.noRentalText')
    }
  }), _c('v-divider', {
    staticClass: "my-4"
  }), _c('div', {
    staticClass: "mb-4"
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.contract.customer.approvals")) + " ")]), _c('rental-approval-limits-sheet', {
    attrs: {
      "rentalCarDailyRate": _vm.rental.dailyRate,
      "rentalCarDays": _vm.duration
    },
    model: {
      value: _vm.report,
      callback: function callback($$v) {
        _vm.report = $$v;
      },
      expression: "report"
    }
  })], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "outlined": "",
      "loading": _vm.requestsLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.createAndClose();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.requestsLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.createReportAndSend();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("createAndSend")) + " ")])], 1)], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.Steps.SEND_MAIL
    }
  }, [_c('v-card-text', [_vm.Steps.SEND_MAIL === _vm.step ? _c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.CREATE_RENTAL_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.rental.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.report.customerContact ? [_vm.report.customerContact.email] : [],
      "refs": [{
        refId: _vm.rental.id,
        refType: _vm.ResourceEnum.RENTAL
      }, {
        refId: _vm.report.id,
        refType: _vm.ResourceEnum.REPORT
      }],
      "isTicketEnabled": true,
      "attachmentFileFilters": _vm.attachmentFileFilters
    }
  }) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.requestsLoading
    },
    on: {
      "click": function click() {
        return _vm.sendMail();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }